module.exports = __webpack_public_path__ + "img/es-ist-ein-ros.7d67e8f1.jpeg";